import $ from 'jquery';

const CommonHelper = {

    scrollToSelector($element) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $($element).offset().top - 30
        }, 0);
    }
};

export default CommonHelper;
